import React, { ComponentProps, CSSProperties, useRef } from "react";
import useIntersectionObserver from "../../../../hooks/useIntersectionObserver.hook";
import "./styles.css";

type AnimatedImageProps = ComponentProps<"img"> & {
  containerClassName?: string;
  containerStyle?: CSSProperties;
};

const AnimatedImage: React.FC<AnimatedImageProps> = ({
  containerClassName = "",
  containerStyle,
  ...props
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [observe, entry] = useIntersectionObserver({ threshold: 0.1 });

  React.useEffect(() => {
    if (ref.current) {
      observe(ref.current);
    }
  }, [observe]);

  const isVisible = entry?.isIntersecting;

  return (
    <div
      ref={ref}
      className={`taptap-image-fade-in ${
        isVisible  ? "image-is-visible" : ""
      } ${containerClassName}`}
      style={containerStyle}
    >
      <img {...props} />
    </div>
  );
};

export default AnimatedImage;
